import React from 'react';

import Icon from 'presentation/icons';

import {OptionsDrawerItem} from '../../types';
import {OptionIcon} from '../OptionIcon';
import {
	StyledOptionCard,
	StyledOptionLabelGroup,
	StyledOptionLink,
	StyledOptionMainAction,
} from './styles';

export function OptionWithLink({label, icon, imageSrc, link, onClick}: OptionsDrawerItem) {
	return (
		<StyledOptionCard as="div">
			<OptionIcon icon={icon} imageSrc={imageSrc} />
			<StyledOptionLabelGroup>
				<StyledOptionMainAction type="button" onClick={onClick}>
					<span>{label}</span>
				</StyledOptionMainAction>
				{link ? (
					<StyledOptionLink type="button" onClick={link.onClick}>
						{link.label}
					</StyledOptionLink>
				) : null}
			</StyledOptionLabelGroup>
			<Icon name="arrow-right" aria-hidden />
		</StyledOptionCard>
	);
}
